import axios from 'axios'
import { environment } from '@/data/environment/'
import { refreshToken } from '@/auth/refreshJwt'

export default {
  namespaced: true,
  state: {
    statusResponse: false,
    statusBinesResponse: false,
    statusDeleteBinResponse: null,
    statusDeleteTerminalResponse: null,
    updateStatusResponse: false,
    updateStatusTimeOutResponse: false,
    listCredentials: [],
    listTerminales: [],
    listBines: [],
  },
  mutations: {

    setListCredentials (state, data) {
      state.listCredentials = data
    },
    setListTerminales (state, data) {
      state.listTerminales = data
    },
    setListBines (state, data) {
      state.listBines = data
    },
    setResponseDeleteBin (state, data) {
      state.statusDeleteBinResponse = data
    },
    setResponseDeleteTerminal (state, data) {
      state.statusDeleteTerminalResponse = data
    },
    setResponseCredentials (state, data) {
      state.statusResponse = data
    },
    setResponseBines (state, data) {
      state.statusBinesResponse = data
    },
    setUpdateResponseCredentials (state, data) {
      state.updateStatusResponse = data
    },
    setUpdateResponseTimeOut (state, data) {
      state.updateStatusTimeOutResponse = data
    },
  },
  actions: {
    getListCredentials ({ commit }) {
      let params = 'IdCompania='
      const endpoint = '/credentialsAll?'
      const user = JSON.parse(atob(localStorage.getItem('uid')))
      const rol = JSON.parse(localStorage.getItem('role') || "[]")
      const validateRol = rol.includes('Administrador')
      if (validateRol) {
        params += '-1'
      } else {
        params += user.idcompania
      }

      const url = environment.HIOPOSWEBSERVICES + endpoint + params
      axios.create({
        headers: {
          Authorization: `Bearer ${user.jwt}`,
        },
      }).get(url)
        .then(response => {
          if (response.data.respuesta?.Mensaje === 'token_invalid') {
            refreshToken().then(() => {
              const newJwt = JSON.parse(atob(localStorage.getItem('uid'))).jwt
              const newAxiosInstance = axios.create({
                headers: {
                  Authorization: `Bearer ${newJwt}`,
                },
              })

              return newAxiosInstance.get(url)
            })
              .then(response => {
                commit('setListCredentials', response.data.respuesta.Datos)
              })
              .catch(error => {
                console.log('Error al renovar el token o al realizar la nueva solicitud:', error.message)
              })
          } else {
            commit('setListCredentials', response.data.respuesta.Datos)
          }
        })
        .catch(error => {
          console.log('Error en la solicitud original:', error.message)
        })
    },
    updateCredentials ({ commit }, data) {
      const endpoint = '/credentials'
      const url = environment.HIOPOSWEBSERVICES + endpoint
      data = { token_key: data.token_key, observation: data.observation, code_store: data.code_store, user: data.user, data_integration: data.dataCredentials }

      const user = JSON.parse(atob(localStorage.getItem('uid')))
      axios.create({
        headers: {
          Authorization: `Bearer ${user.jwt}`,
        },
      }).put(url, data)
        .then(response => {
          if (response.data.respuesta?.Mensaje === 'token_invalid') {
            refreshToken().then(() => {
              const newJwt = JSON.parse(atob(localStorage.getItem('uid'))).jwt
              const newAxiosInstance = axios.create({
                headers: {
                  Authorization: `Bearer ${newJwt}`,
                },
              })
              return newAxiosInstance.put(url, data)
            })
              .then(response => {
                commit('setUpdateResponseCredentials', response.statusText === 'OK')
              })
              .catch(function (error) {
                console.log(error.message)
              })
          } else {
            commit('setUpdateResponseCredentials', response.statusText === 'OK')
          }
        })
        .catch(function (error) {
          console.log(error.message)
        })
    },
    updateCredentialsTimeOut ({ commit }, data) {
      const endpoint = '/credentialsTimeout'
      data = { token_key: data.token_key, observation: data.observation, code_store: data.code_store, user: data.user, time_out_initial: data.time_out_initial, time_out_sequential: data.time_out_sequential }
      const url = environment.HIOPOSWEBSERVICES + endpoint

      const user = JSON.parse(atob(localStorage.getItem('uid')))
      axios.create({
        headers: {
          Authorization: `Bearer ${user.jwt}`,
        },
      }).put(url, data)
        .then(response => {
          if (response.data.respuesta?.Mensaje === 'token_invalid') {
            refreshToken().then(() => {
              const newJwt = JSON.parse(atob(localStorage.getItem('uid'))).jwt
              const newAxiosInstance = axios.create({
                headers: {
                  Authorization: `Bearer ${newJwt}`,
                },
              })
              return newAxiosInstance.put(url, data)
            })
              .then(response => {
                commit('setUpdateResponseTimeOut', response.statusText === 'OK')
            })
              .catch(function (error) {
                console.log(error.message)
              })
          } else {
            commit('setUpdateResponseTimeOut', response.statusText === 'OK')
          }
        })
        .catch(function (error) {
          console.log(error.message)
        })
    },
    getListTerminales ({ commit }, data) {
      let params = `&client=${data.Client}`
      params += `&type_tef=${data.Tef}`

      const endpoint = '/credentialsClient?'
      const url = environment.HIOPOSWEBSERVICES + endpoint + params

      const user = JSON.parse(atob(localStorage.getItem('uid')))
      axios.create({
        headers: {
          Authorization: `Bearer ${user.jwt}`,
        },
      }).get(url)
        .then(response => {
          if (response.data.respuesta?.Mensaje === 'token_invalid') {
            refreshToken().then(() => {
              const newJwt = JSON.parse(atob(localStorage.getItem('uid'))).jwt
              const newAxiosInstance = axios.create({
                headers: {
                  Authorization: `Bearer ${newJwt}`,
                },
              })

              return newAxiosInstance.get(url)
            })
              .then(response => {
                commit('setListTerminales', response.data.respuesta.Datos)
              })
              .catch(function (error) {
                console.log(error.message)
              })
          } else {
            commit('setListTerminales', response.data.respuesta.Datos)
          }
        })
        .catch(function (error) {
          console.log(error.message)
        })
    },
    insertCredentials ({ commit }, data) {
      const endpoint = '/credentials'
      const url = environment.HIOPOSWEBSERVICES + endpoint

      const user = JSON.parse(atob(localStorage.getItem('uid')))
      axios.create({
        headers: {
          Authorization: `Bearer ${user.jwt}`,
        },
      }).post(url, data)
        .then(response => {
          if (response.data.respuesta?.Mensaje === 'token_invalid') {
            refreshToken().then(() => {
              const newJwt = JSON.parse(atob(localStorage.getItem('uid'))).jwt
              const newAxiosInstance = axios.create({
                headers: {
                  Authorization: `Bearer ${newJwt}`,
                },
              })

              return newAxiosInstance.post(url, data)
            })
              .then(response => {
                if (response.data) {
                  commit('setResponseCredentials', response.data.respuesta)
                }
              })
              .catch(function (error) {
                console.log(error.message)
              })
          } else {
            if (response.data) {
              commit('setResponseCredentials', response.data.respuesta)
            }
          }
        })
        .catch(function (error) {
          console.log(error.message)
        })
    },
    insertBines ({ commit }, data) {
      const endpoint = '/bines'
      const url = environment.HIOPOSWEBSERVICES + endpoint
      const user = JSON.parse(atob(localStorage.getItem('uid')))
      axios.create({
        headers: {
          Authorization: `Bearer ${user.jwt}`,
        },
      }).post(url, data)
        .then(response => {
            if (response.data.respuesta?.Mensaje === 'token_invalid') {
              refreshToken().then(() => {
                const newJwt = JSON.parse(atob(localStorage.getItem('uid'))).jwt
                const newAxiosInstance = axios.create({
                  headers: {
                    Authorization: `Bearer ${newJwt}`,
                  },
                })

                return newAxiosInstance.post(url, data)
              })
                .then(response => {
                  if (response.data) {
                    commit('setResponseBines', response.data.respuesta)
                  }
                })
                .catch(function (error) {
                  console.log(error.message)
                })
            } else {
              if (response.data) {
                commit('setResponseBines', response.data.respuesta)
              }
            }
        })
        .catch(function (error) {
          console.log(error.message)
        })
    },
    getListBines ({ commit }, data) {
      let params = `&Cliente=${data.Client}`
      params += `&IdCompania=${JSON.parse(atob(localStorage.getItem('uid'))).idcompania}`

      const endpoint = '/bines?'
      const url = environment.HIOPOSWEBSERVICES + endpoint + params
      const user = JSON.parse(atob(localStorage.getItem('uid')))
      axios.create({
        headers: {
          Authorization: `Bearer ${user.jwt}`,
        },
      })
        .get(url)
        .then(response => {
            if (response.data.respuesta?.Mensaje === 'token_invalid') {
              refreshToken().then(() => {
                const newJwt = JSON.parse(atob(localStorage.getItem('uid'))).jwt
                const newAxiosInstance = axios.create({
                  headers: {
                    Authorization: `Bearer ${newJwt}`,
                  },
                })

                return newAxiosInstance.get(url)
              })
                .then(response => {
                  commit('setListBines', response.data.respuesta.Datos)
                })
                .catch(function (error) {
                  console.log(error.message)
                })
            } else {
              commit('setListBines', response.data.respuesta.Datos)
            }
        })
        .catch(function (error) {
          console.log(error.message)
        })
    },
    deleteBin ({ commit }, data) {
      const endpoint = '/bin'
      data = { IdCompania: JSON.parse(atob(localStorage.getItem('uid'))).idcompania, Cliente: data.client, BIN: data.bin }
      const url = environment.HIOPOSWEBSERVICES + endpoint
      const user = JSON.parse(atob(localStorage.getItem('uid')))
      axios.create({
        headers: {
          Authorization: `Bearer ${user.jwt}`,
        },
      })
        .put(url, data)
        .then(response => {
            if (response.data.respuesta?.Mensaje === 'token_invalid') {
              refreshToken().then(() => {
                const newJwt = JSON.parse(atob(localStorage.getItem('uid'))).jwt
                const newAxiosInstance = axios.create({
                  headers: {
                    Authorization: `Bearer ${newJwt}`,
                  },
                })

                return newAxiosInstance.put(url, data)
              })
                .then(response => {
                  commit('setResponseDeleteBin', response.data.respuesta.Error)
                })
                .catch(function (error) {
                  console.log(error.message)
                })
            } else {
              commit('setResponseDeleteBin', response.data.respuesta.Error)
            }
        })
        .catch(function (error) {
          console.log(error.message)
        })
    },
    deleteTerminal ({ commit }, data) {
      const endpoint = '/credential'
      data = {
      idCompania: JSON.parse(atob(localStorage.getItem('uid'))).idcompania,
      client: data.client,
              code_terminal: data.code_terminal,
      code_store: data.code_store,
      }
      const url = environment.HIOPOSWEBSERVICES + endpoint
      const user = JSON.parse(atob(localStorage.getItem('uid')))
      axios.create({
        headers: {
          Authorization: `Bearer ${user.jwt}`,
        },
      })
        .put(url, data)
        .then(response => {
          if (response.data.respuesta?.Mensaje === 'token_invalid') {
            refreshToken().then(() => {
              const newJwt = JSON.parse(atob(localStorage.getItem('uid'))).jwt
              const newAxiosInstance = axios.create({
                headers: {
                  Authorization: `Bearer ${newJwt}`,
                },
              })

              return newAxiosInstance.put(url, data)
            })
              .then(response => {
                commit('setResponseDeleteTerminal', response.data.respuesta.Error)
              })
              .catch(function (error) {
                console.log(error.message)
              })
          } else {
            commit('setResponseDeleteTerminal', response.data.respuesta.Error)
          }
        })
        .catch(function (error) {
          console.log(error.message)
        })
    },
    setUpdateResponseCredentials ({ commit }, data) {
      commit('setUpdateResponseCredentials', data)
    },
    setUpdateResponseTimeOut ({ commit }, data) {
      commit('setUpdateResponseTimeOut', data)
    },
    setUpdateResponseDeleteBin ({ commit }, data) {
      commit('setResponseDeleteBin', data)
    },
    setUpdateResponseDeleteTerminal ({ commit }, data) {
      commit('setResponseDeleteTerminal', data)
    },
  },
}
